import Reguler from '@bvt-features/danone/assets/marker/reguler.png';
import Express from '@bvt-features/danone/assets/marker/express.png';
import Pet from '@bvt-features/danone/assets/marker/pet.png';
import Grabmart from '@bvt-features/danone/assets/marker/grabmart.png';
import Tokopedia from '@bvt-features/danone/assets/marker/tokopedia.png';
import Bronze from '@bvt-features/danone/assets/marker/bronze.png';
import Silver from '@bvt-features/danone/assets/marker/silver.png';
import Gold from '@bvt-features/danone/assets/marker/gold.png';
import Diamond from '@bvt-features/danone/assets/marker/diamond.png';
import GTRetail from '@bvt-features/danone/assets/marker/gt_retail.png';
import GTWS from '@bvt-features/danone/assets/marker/gt_ws.png';
import MiniNka from '@bvt-features/danone/assets/marker/mini_nka.png';

import LowLegend from '@bvt-features/danone/assets/legend/low-density.png';
import MediumLowLegend from '@bvt-features/danone/assets/legend/medium-low-density.png';
import MediumHighLegend from '@bvt-features/danone/assets/legend/medium-high-density.png';
import HighLegend from '@bvt-features/danone/assets/legend/high-density.png';

import LowLegendBCCD from '@bvt-features/danone/assets/legend/low_coverage_ses_bc.png';
import MediumLowLegendBCCD from '@bvt-features/danone/assets/legend/medium_low_coverage_ses_bc.png';
import MediumHighLegendBCCD from '@bvt-features/danone/assets/legend/medium_high_coverage_ses_bc.png';
import HighLegendBCCD from '@bvt-features/danone/assets/legend/high_coverage_ses_bc.png';

export const markerIcon = {
  'AHS Reguler': Reguler,
  'AQUA Express': Express,
  'AHS P.E.T': Pet,
  'AHS Grabmart': Grabmart,
  'AHS Tokopedia': Tokopedia,
  'AHS Bronze': Bronze,
  'AHS Silver': Silver,
  'AHS Gold': Gold,
  'AHS Diamond': Diamond,
  'GT Retail': GTRetail,
  'GT-WS': GTWS,
  'MINI NKA': MiniNka,
};

export const markerLegend = {
  'AHS Reguler': { title: 'AHS Reguler', icon: Reguler },
  'AQUA Express': { title: 'AQUA Express', icon: Express },
  'AHS P.E.T': { title: 'AHS P.E.T', icon: Pet },
  'AHS Grabmart': { title: 'AHS Grabmart', icon: Grabmart },
  'AHS Tokopedia': { title: 'AHS Tokopedia', icon: Tokopedia },
  'AHS Bronze': { title: 'AHS Bronze', icon: Bronze },
  'AHS Silver': { title: 'AHS Silver', icon: Silver },
  'AHS Gold': { title: 'AHS Gold', icon: Gold },
  'AHS Diamond': { title: 'AHS Diamond', icon: Diamond },
  'GT Retail': { title: 'GT Retail', icon: GTRetail },
  'GT-WS': { title: 'GT WS', icon: GTWS },
  'MINI NKA': { title: 'MINI NKA', icon: MiniNka },
};

export const polygonLegend = {
  high: { title: 'High Coverage (>=5 AHS) SES AB', icon: HighLegend },
  highBCCD: {
    title: 'High Coverage (>=5 AHS) SES BC/CD',
    icon: HighLegendBCCD,
  },
  mediumHigh: {
    title: 'Medium - High Coverage (3-4 AHS) SES AB',
    icon: MediumHighLegend,
  },
  mediumHighBCCD: {
    title: 'Medium - High Coverage (3-4 AHS) SES BC/CD',
    icon: MediumHighLegendBCCD,
  },
  mediumLow: {
    title: 'Medium - Low Coverage (1-2 AHS) SES AB',
    icon: MediumLowLegend,
  },
  mediumLowBCCD: {
    title: 'Medium - Low Coverage (1-2 AHS) SES BC/CD',
    icon: MediumLowLegendBCCD,
  },
  low: { title: 'Low Coverage (0 AHS) SES AB', icon: LowLegend },
  lowBCCD: { title: 'Low Coverage (0 AHS) SES BC/CD', icon: LowLegendBCCD },
};
